export default __webpack_public_path__ + "static/media/s005.c00d46f1.jpeg";